<div class="rte" [class.rte-invalid]="invalid" [class.rte-fullscreen]="fullscreen" [class.rte-disabled]="disabled">
  <div class="rte-toolbar" role="toolbar" aria-label="Formato del contenido" (mousedown)="keepSelection($event)">
    <div class="rte-group" data-group="Historial">
      <button type="button" title="Deshacer (Ctrl+Z)" aria-label="Deshacer" (click)="exec('undo')"><i class="bi bi-arrow-counterclockwise"></i></button>
      <button type="button" title="Rehacer (Ctrl+Y)" aria-label="Rehacer" (click)="exec('redo')"><i class="bi bi-arrow-clockwise"></i></button>
    </div>
    <div class="rte-group rte-style-group" data-group="Estilo">
      <label class="sr-only" for="policy-block-style">Estilo del párrafo</label>
      <select id="policy-block-style" title="Estilo del párrafo" [value]="block" (change)="setBlock($any($event.target).value)">
        <option *ngFor="let option of blocks" [value]="option.value">{{ option.label }}</option>
      </select>
    </div>
    <div class="rte-group" data-group="Texto">
      <button type="button" title="Negrita (Ctrl+B)" aria-label="Negrita" [class.active]="active['bold']" (click)="exec('bold')"><i class="bi bi-type-bold"></i></button>
      <button type="button" title="Cursiva (Ctrl+I)" aria-label="Cursiva" [class.active]="active['italic']" (click)="exec('italic')"><i class="bi bi-type-italic"></i></button>
      <button type="button" title="Subrayado (Ctrl+U)" aria-label="Subrayado" [class.active]="active['underline']" (click)="exec('underline')"><i class="bi bi-type-underline"></i></button>
      <button type="button" title="Tachado" aria-label="Tachado" [class.active]="active['strikeThrough']" (click)="exec('strikeThrough')"><i class="bi bi-type-strikethrough"></i></button>
    </div>
    <div class="rte-group" data-group="Alineación">
      <button type="button" title="Alinear a la izquierda" aria-label="Alinear a la izquierda" [class.active]="active['justifyLeft']" (click)="exec('justifyLeft')"><i class="bi bi-text-left"></i></button>
      <button type="button" title="Centrar" aria-label="Centrar" [class.active]="active['justifyCenter']" (click)="exec('justifyCenter')"><i class="bi bi-text-center"></i></button>
      <button type="button" title="Alinear a la derecha" aria-label="Alinear a la derecha" [class.active]="active['justifyRight']" (click)="exec('justifyRight')"><i class="bi bi-text-right"></i></button>
      <button type="button" title="Justificar" aria-label="Justificar" [class.active]="active['justifyFull']" (click)="exec('justifyFull')"><i class="bi bi-justify"></i></button>
    </div>
    <div class="rte-group" data-group="Listas">
      <button type="button" title="Lista con viñetas" aria-label="Lista con viñetas" [class.active]="active['insertUnorderedList']" (click)="exec('insertUnorderedList')"><i class="bi bi-list-ul"></i></button>
      <button type="button" title="Lista numerada" aria-label="Lista numerada" [class.active]="active['insertOrderedList']" (click)="exec('insertOrderedList')"><i class="bi bi-list-ol"></i></button>
      <button type="button" title="Disminuir sangría" aria-label="Disminuir sangría" (click)="exec('outdent')"><i class="bi bi-text-indent-right"></i></button>
      <button type="button" title="Aumentar sangría" aria-label="Aumentar sangría" (click)="exec('indent')"><i class="bi bi-text-indent-left"></i></button>
    </div>
    <div class="rte-group" data-group="Insertar">
      <button type="button" title="Agregar enlace" aria-label="Agregar enlace" (click)="addLink()"><i class="bi bi-link-45deg"></i></button>
      <button type="button" title="Quitar formato" aria-label="Quitar formato" (click)="clearFormatting()"><i class="bi bi-eraser"></i></button>
    </div>
    <button type="button" class="rte-expand" [title]="fullscreen ? 'Salir de pantalla completa' : 'Editar en pantalla completa'" [attr.aria-label]="fullscreen ? 'Salir de pantalla completa' : 'Editar en pantalla completa'" (click)="toggleFullscreen()">
      <i class="bi" [class.bi-fullscreen]="!fullscreen" [class.bi-fullscreen-exit]="fullscreen"></i>
    </button>
  </div>

  <div class="rte-workspace">
    <div class="rte-paper">
      <div
        #editor
        class="rte-page"
        role="textbox"
        aria-multiline="true"
        aria-label="Contenido de la política"
        name="content"
        [attr.data-placeholder]="placeholder"
        [attr.contenteditable]="disabled ? 'false' : 'true'"
        [attr.aria-disabled]="disabled"
        [attr.aria-invalid]="invalid"
        spellcheck="true"
        (input)="onInput()"
        (blur)="onBlur()"
        (paste)="onPaste($event)"
      ></div>
    </div>
  </div>

  <div class="rte-status" aria-live="polite">
    <span><i class="bi bi-shield-check"></i> El formato se guarda de manera segura.</span>
    <span>{{ words }} {{ words === 1 ? 'palabra' : 'palabras' }} · {{ htmlLength | number }}/{{ maxLength | number }}</span>
  </div>
</div>
